// import { setLocalUserInfoApi, getLocalUserInfoApi } from '@/utils/storage'
import { getCartListApi, updateCartGoodsApi, deleteCartGoodsApi } from '@/api/cart'
// import { Toast } from 'vant'
export default {
  // 开启命名空间
  namespaced: true,
  state () {
    return {
      // 首次进入页面时优先从本地获取
      cartList: []
    }
  },
  mutations: {
    // 设置购物车信息
    setCartList (state, list) {
      state.cartList = list
    },
    // 修改商品选中状态
    changeSelGood (state, id) {
      const res = state.cartList.find(item => item.id === id)
      // cartList中存的都是对象，是复杂数据类型，所以这里赋值只是将地址赋给了res
      // 更改res，其实就更改 cartList中的那个res
      if (res) { res.isChecked = !res.isChecked }
    },
    // 是否全选
    isAll (state, bool) {
      state.cartList.forEach(item => {
        item.isChecked = bool
      })
    },
    // 更改商品数量
    changeGoodsNum (state, { goodsId, goodsNum }) {
      const res = state.cartList.find(item => item.goods_id === goodsId)
      res.goods_num = goodsNum
    },
    // 删除本地的购物车商品数据
    deleteLocalGoods (state) {
      state.cartList = state.cartList.filter(item => !item.isChecked)
    }
  },
  actions: {
    // 获取购物车信息
    async getCartList (context) {
      const { data: { list } } = await getCartListApi()
      // 由于服务器传过来的数据并没有是否勾选商品的属性，所以需要自己加
      list.forEach(item => {
        item.isChecked = true
      })
      // console.log(list)
      context.commit('setCartList', list)
    },
    // 更新服务器购物车信息
    async updateCartGoodsInfo (context, obj) {
      // 更新服务器端购物车信息
      await updateCartGoodsApi(obj)
      // 更新完成后，再更新下本地的vuex数据
      // 不能用下面这个方法，不然会导致所有商品的勾选状态被重置为true，而且向服务器请求数据会消耗服务器性能
      // context.dispatch('getCartList')
      // 应使用这个方法更新本地数据，而不是向服务器获取购物车信息更新本地数据
      context.commit('changeGoodsNum', obj)
    },
    // 删除购物车商品
    async deleteCartGoods (context) {
      // 获取已选商品的购物车id
      const cartIds = context.getters.selGoods.map(item => item.id)
      await deleteCartGoodsApi(cartIds)
      // 删除本地商品数据
      context.commit('deleteLocalGoods')
    }
  },
  getters: {
    // 商品总数量
    cartGoodsTotal (state) {
      return state.cartList.reduce((sum, item) => sum + item.goods_num, 0)
    },
    // 选中的商品
    selGoods (state) {
      return state.cartList.filter(item => item.isChecked === true)
    },
    selGoodsNum (state, getters) {
      return getters.selGoods.reduce((sum, item) => sum + item.goods_num, 0)
    },
    // 选中的商品的总价格
    selGoodsTotalPrice (state, getters) {
      return getters.selGoods.reduce((sum, item) => sum + item.goods_num * item.goods.goods_price_min, 0).toFixed(2)
    }
  }
}
